/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = [''];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiQzovVXNlcnMvWWktWXUvRG9jdW1lbnRzL0FjdHVhbCBEb2N1bWVudHMvS2F0aXNvL2thdGlzby9zcmMvYXBwL2NvbXBvbmVudHMvZXJyb3JzL2Vycm9ycy5jb21wb25lbnQuc2Nzcy5zaGltLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9DOi9Vc2Vycy9ZaS1ZdS9Eb2N1bWVudHMvQWN0dWFsIERvY3VtZW50cy9LYXRpc28va2F0aXNvL3NyYy9hcHAvY29tcG9uZW50cy9lcnJvcnMvZXJyb3JzLmNvbXBvbmVudC5zY3NzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7OzsifQ==



// WEBPACK FOOTER //
// C:/Users/Yi-Yu/Documents/Actual Documents/Katiso/katiso/src/$$_gendir/app/components/errors/errors.component.scss.shim.ngstyle.ts